import { makeApi } from "@zodios/core";
import { z } from "zod";

import { MaacFeatureSettingsSchema } from "../models";

const api = makeApi([
  {
    alias: "organizationSetting",
    method: "get",
    path: "/api/v1/organizations/setting",
    response: z.object({
      id: z.number().int().positive(),
      wccsAvailableWccsChannelNum: z.number(),
      wccsWebChatModuleEnabled: z.boolean(),
      wccsWebFootprintTrackingEnabled: z.boolean(),
      wccsSmartRedirectToolEnabled: z.boolean(),
      wccsWebStreamsModuleAvailable: z.boolean(),
      /**
       * Paid capability: the org may hide the Web Chat footer per channel.
       * `.catch(false)` rather than a strict boolean like its siblings: this
       * response gates every WCCS module switch, so a deploy that reaches
       * Admin Center before interlude sends the field must not fail the
       * whole parse.
       */
      wccsCustomChatFooterEnabled: z.boolean().catch(false),
      maacFeatureSettings: MaacFeatureSettingsSchema,
      productFeedModuleEnabled: z.boolean(),
      customFieldLimit: z.number().int(),
      openApiV2Enabled: z.boolean(),
      mcpEnabled: z.boolean(),
    }),
  },
  {
    alias: "hasEcModule",
    method: "get",
    path: "/api/v1/organizations/has-ec-module",
    response: z.object({
      hasEcModule: z.boolean(),
    }),
  },
]);

export { api };
